module.exports = __webpack_public_path__ + "2db6c315e0b043fd3f664bd7e6308ca9.svg";